<div class="dashboard-page">

  <!-- ── Row 1: Stats panels ─────────────────────────────── -->
  <div class="dashboard-container">
    <div class="dashboard-panel" *ngFor="let panel of panels">

      <div class="panel-header">
        <div class="panel-title">
          <svg class="panel-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
               fill="none" stroke="currentColor" stroke-width="2"
               stroke-linecap="round" stroke-linejoin="round">
            <path [attr.d]="panel.iconPath"></path>
          </svg>
          <span class="panel-title-text">{{ panel.title }}</span>
        </div>
   </div>

      <div class="panel-body" *ngIf="!loadingMain">
        <div class="stat-item" *ngFor="let stat of panel.stats">
          <div class="stat-label">
            <span class="dot" [ngClass]="stat.dotClass"></span>
            {{ stat.label }}
          </div>
          <div class="stat-value" [ngClass]="stat.colorClass">{{ formatValue(stat.value) }}</div>
        </div>
      </div>
      <div class="panel-body skeleton-body" *ngIf="loadingMain">
        <div class="skeleton-stat" *ngFor="let s of [1,2,3]">
          <div class="skeleton-line skeleton-sm"></div>
          <div class="skeleton-line skeleton-lg"></div>
        </div>
      </div>

    </div>
  </div>

  <!-- ── Row 2: Allocation Overview panels ──────────────── -->
  <div class="dashboard-container">
    <ng-container *ngIf="!loadingMain">
      <div class="overview-card" *ngFor="let ov of allocationOverviews">

        <div class="overview-header">
          <span class="overview-title">{{ ov.centerLabel }} Overview</span>
        </div>

        <div class="donut-wrapper">
          <svg viewBox="0 0 100 100" class="donut-svg">
            <g transform="rotate(-90 50 50)">
              <circle *ngFor="let seg of ov.segments"
                      cx="50" cy="50" r="35"
                      fill="none"
                      [attr.stroke]="seg.color"
                      stroke-width="14"
                      [attr.stroke-dasharray]="seg.dasharray"
                      [attr.stroke-dashoffset]="seg.dashoffset">
                <title>{{ seg.label }}: {{ formatValue(seg.value) }}</title>
              </circle>
            </g>
            <!-- Center labels -->
            <text x="50" y="43" text-anchor="middle" class="donut-text-top">Total</text>
            <text x="50" y="52" text-anchor="middle" class="donut-text-mid">{{ ov.centerLabel }}</text>
            <text x="50" y="71" text-anchor="middle" class="donut-text-val">{{ formatValue(ov.total) }}</text>
          </svg>
        </div>

      </div>
    </ng-container>
    <ng-container *ngIf="loadingMain">
      <div class="overview-card" *ngFor="let panel of panels">
        <div class="overview-header">
          <span class="overview-title">{{ panel.title }} Overview</span>
        </div>
        <div class="donut-wrapper skeleton-donut-wrapper">
          <div class="skeleton-donut"></div>
        </div>
      </div>
    </ng-container>
  </div>

  <!-- ── Row 3: Allocation by Unit ──────────────────────── -->
  <div class="dashboard-container">
    <ng-container *ngIf="!loadingMain">
      <div class="unit-card" *ngFor="let section of allocationByUnits">

        <div class="unit-card-header">
          <span class="unit-card-title">{{ section.title }}</span>
        </div>

        <table class="unit-table">
          <thead>
            <tr>
              <th class="col-unit">Unit</th>
              <th class="col-num col-green-h">Allocated</th>
              <th class="col-num col-orange-h">Produce</th>
              <th class="col-num col-red-h">Errors</th>
              <th class="col-status">Status</th>
              <th class="col-arrow"></th>
            </tr>
          </thead>
          <tbody>
            <tr class="unit-row" *ngFor="let row of section.rows">
              <td class="col-unit">
                <div class="unit-name-cell">
                  <span class="unit-icon-wrap">
                    <svg class="unit-row-icon" viewBox="0 0 24 24" fill="none"
                         stroke="currentColor" stroke-width="1.8"
                         stroke-linecap="round" stroke-linejoin="round">
                      <path [attr.d]="row.iconPath"></path>
                    </svg>
                  </span>
                  <span class="unit-name">{{ row.name }}</span>
                </div>
              </td>
              <td class="col-num stat-green">{{ formatValue(row.allocated) }}</td>
              <td class="col-num stat-orange">{{ formatValue(row.produce) }}</td>
              <td class="col-num stat-red">{{ formatValue(row.errors) }}</td>
              <td class="col-status">
                <div class="status-cell">
                  <span class="dot" [ngClass]="row.status === 'Allocated' ? 'dot-green' : 'dot-red'"></span>
                  <span class="status-text">{{ row.status }}</span>
                </div>
              </td>
              <td class="col-arrow">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
                     stroke="currentColor" stroke-width="2.5"
                     stroke-linecap="round" stroke-linejoin="round">
                  <polyline points="9 18 15 12 9 6"></polyline>
                </svg>
              </td>
            </tr>
          </tbody>
        </table>

      </div>
    </ng-container>
    <ng-container *ngIf="loadingMain">
      <div class="unit-card" *ngFor="let i of [1,2]">
        <div class="unit-card-header">
          <div class="skeleton-line skeleton-title"></div>
        </div>
        <div class="skeleton-table">
          <div class="skeleton-row" *ngFor="let r of [1,2,3,4]">
            <div class="skeleton-line skeleton-cell"></div>
            <div class="skeleton-line skeleton-cell-sm"></div>
            <div class="skeleton-line skeleton-cell-sm"></div>
            <div class="skeleton-line skeleton-cell-sm"></div>
          </div>
        </div>
      </div>
    </ng-container>

    <!-- Simulation Details -->
    <div class="unit-card">
      <div class="unit-card-header">
        <span class="unit-card-title">Simulation Details</span>
      </div>

      <ng-container *ngIf="loadingSimDetails">
        <div class="skeleton-table">
          <div class="skeleton-row" *ngFor="let r of [1,2]">
            <div class="skeleton-line skeleton-cell"></div>
            <div class="skeleton-line skeleton-cell-sm"></div>
          </div>
        </div>
      </ng-container>

      <table class="unit-table" *ngIf="!loadingSimDetails">
        <thead>
          <tr>
            <th class="col-unit">Market</th>
            <th class="col-num">Total Missing Count</th>
          </tr>
        </thead>
        <tbody>
          <tr class="unit-row" *ngIf="missingPartMarket1">
            <td class="col-unit">
              <div class="unit-name-cell">
                <span class="unit-name">{{ missingPartMarket1.marketName }}</span>
              </div>
            </td>
            <td class="col-num stat-green">{{ formatValue(missingPartMarket1.totalCount) }}</td>
          </tr>
          <tr class="unit-row" *ngIf="missingPartMarket2">
            <td class="col-unit">
              <div class="unit-name-cell">
                <span class="unit-name">{{ missingPartMarket2.marketName }}</span>
              </div>
            </td>
            <td class="col-num stat-green">{{ formatValue(missingPartMarket2.totalCount) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

</div>
